import type { Plugin } from 'chart.js';

import { getCssVar } from './get-css-var';

/**
 * Chart.js plugin that draws a vertical crosshair line from the hovered data point
 * down to the X-axis, using the `--mi-primary-main` brand color.
 */
export const crosshairPlugin: Plugin<'line'> = {
  id: 'crosshair',
  afterDatasetsDraw(chart) {
    const activeElements = chart.tooltip?.getActiveElements();

    if (activeElements?.length) {
      const { x, y } = activeElements[0].element;
      const { bottom } = chart.chartArea;
      const ctx = chart.ctx;

      ctx.save();
      ctx.beginPath();
      ctx.moveTo(x, y);
      ctx.lineTo(x, bottom);
      ctx.lineWidth = 1;
      ctx.strokeStyle = getCssVar('--mi-primary-main');
      ctx.stroke();
      ctx.restore();
    }
  },
};
